module.exports = __webpack_public_path__ + "media/images/check-a1bc271caed96b83b3cb26e88724a0e8.svg";